// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IvPJ","colBig":"styles_colBig__3Fht_","colSmall":"styles_colSmall__1vNuN"};